!(function() {
  var layoutComputerUtils = require('./Izenda.LayoutComputerUtils');

  var SWAP_INTERSECT_RATIO = 0.33;
  const { clone, findIndex, find, filter, placeholder } = require('lodash/fp');
  function getMaxWidth(layout) {
    return (
      placeholder(layout)
        .map(function(item) {
          return item.left + item.width;
        })
        .max() || 0
    );
  }

  function isCollided(layoutA, layoutB) {
    if (layoutA.id === layoutB.id) {
      return false; // same element
    }
    if (layoutA.left + layoutA.width <= layoutB.left) {
      return false; // layoutA is left of layoutB
    }
    if (layoutA.left >= layoutB.left + layoutB.width) {
      return false; // layoutA is right of layoutB
    }
    if (layoutA.top + layoutA.height <= layoutB.top) {
      return false; // layoutA is above layoutB
    }
    if (layoutA.top >= layoutB.top + layoutB.height) {
      return false; // layoutA is below layoutB
    }

    return true; // boxes overlap
  }

  function compact(layout) {
    var sorted = sortLayoutItemsByColRow(layout);
    var out = Array(layout.length);
    var compareWith = [];

    for (var i = 0, len = sorted.length; i < len; i++) {
      var l = clone(sorted[i]);
      l = compactItem(compareWith, l);
      compareWith.push(l);
      out[findIndex(sorted[i], layout)] = l;
      delete l.moved;
    }
    return out;
  }

  function compactItem(compareWith, layoutItem) {
    layoutItem.left = Math.min(getMaxWidth(compareWith), layoutItem.left);
    // Move the element up as far as it can go without colliding.
    while (layoutItem.left > 0 && !findOneCollision(compareWith, layoutItem)) {
      layoutItem.left--;
    }

    var collides;
    while ((collides = findOneCollision(compareWith, layoutItem))) {
      layoutItem.left = collides.left + collides.width;
    }
    return layoutItem;
  }

  /**
   * Returns the first item this layout collides with.
   *
   * @param  {Object} layoutItem Layout item.
   * @return {Object|undefined}  A colliding layout item, or undefined.
   */
  function findOneCollision(layout, layoutItem) {
    return find(function(item) {
      return isCollided(layoutItem, item);
    }, layout);
  }

  function findAllCollisions(layout, layoutItem) {
    return filter(function(item) {
      return isCollided(layoutItem, item);
    }, layout);
  }

  /**
   *
   * @param  {Array}      layout Full layout to modify.
   * @param  {LayoutItem} layoutItem      element to move.
   * @param  {Object}     {x,y,width, height}
   * @param  {Boolean}    [isUserAction] If true, designates that the item we're moving is
   *                                     being dragged/resized by the user.
   */
  function move(layout, layoutItem, newPosition, isUserAction) {
    if (
      layoutItem.left === newPosition.left &&
      layoutItem.top === newPosition.top &&
      layoutItem.width === newPosition.width &&
      layoutItem.height === newPosition.height
    ) {
      return layout;
    }

    var isMovingToLeft = layoutItem.left > newPosition.left && layoutItem.width !== newPosition.width;

    layoutItem.left = newPosition.left;
    layoutItem.top = newPosition.top;
    layoutItem.width = newPosition.width;
    layoutItem.height = newPosition.height;
    layoutItem.moved = true;

    var sorted = sortLayoutItemsByColRow(layout);

    if (isMovingToLeft && Array.isArray(sorted)) {
      sorted.reverse();
    }

    var collisions = findAllCollisions(sorted, layoutItem);
    // Move each item that collides away from this element.
    for (var i = 0, len = collisions.length; i < len; i++) {
      var collision = collisions[i];
      // Short circuit so we can't infinite loop
      if (collision.moved) {
        continue;
      }

      // This makes it feel a bit more precise by waiting to swap for just a bit when moving up.
      if (
        layoutItem.left > collision.left &&
        layoutItem.left - collision.left > collision.width * SWAP_INTERSECT_RATIO
      ) {
        continue;
      }

      layout = moveElementAwayFromCollision(layout, layoutItem, collision, isUserAction);
    }

    return layout;
  }

  /**
   * This is where the magic needs to happen - given a collision, move an element away from the collision.
   * We attempt to move it up if there's room, otherwise it goes below.
   *
   * @param  {Array} layout            Full layout to modify.
   * @param  {LayoutItem} collidesWith Layout item we're colliding with.
   * @param  {LayoutItem} itemToMove   Layout item we're moving.
   * @param  {Boolean} [isUserAction]  If true, designates that the item we're moving is being dragged/resized
   *                                   by the user.
   */
  function moveElementAwayFromCollision(layout, collidesWith, itemToMove, isUserAction) {
    if (isUserAction) {
      var fakeItem = {
        left: itemToMove.left,
        top: itemToMove.top,
        width: itemToMove.width,
        height: itemToMove.height,
        id: -1
      };
      fakeItem.left = Math.max(collidesWith.left - itemToMove.width, 0);
      if (!findOneCollision(layout, fakeItem)) {
        return move(layout, itemToMove, fakeItem);
      }
    }

    var newPosition = {
      left: itemToMove.left + 1,
      top: itemToMove.top,
      width: itemToMove.width,
      height: itemToMove.height
    };
    return move(layout, itemToMove, newPosition);
  }

  function sortLayoutItemsByColRow(layout) {
    return [].concat(layout).sort(function(a, b) {
      if (a.left > b.left || (a.left === b.left && a.top > b.top)) {
        return 1;
      }
      return -1;
    });
  }

  function isEqualLayout(a, b) {
    return a.width === b.width && a.height === b.height && a.left === b.left && a.top === b.top;
  }

  module.exports = {
    compact: compact,
    move: move
  };
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/GridLayout/Izenda.GridViewSnapUtils.js